import { observer } from 'mobx-react-lite'
import { IconButton, Typography } from 'shared/ui'
import { AudioPlayer } from 'shared/ui/AudioPlayer'
import { sentEventSentry } from 'entities/Sentry'
import { UiAudioCard } from 'widgets/MessageFormFields/RinglessMessageField/ui/UiAudioCard/UiAudioCard'
import { useRinglessMessageFieldContext } from 'widgets/MessageFormFields/RinglessMessageField/context/ringlessMessageFieldContext'

export const RinglessAudio = observer(
  ({ showDeliveryInfo = true }: { showDeliveryInfo?: boolean }) => {
    const { attachment, onRemoveAudio, onRenameAudio, checkCanRename } =
      useRinglessMessageFieldContext()
    return (
      <UiAudioCard
        headerLeft={
          <Typography
            ariaLabel={'title'}
            tag={'div'}
            variant={'body-md-medium'}
            color={'var(--content-primary-secondary)'}
            ellipsis
            tooltipProps={{
              label: attachment?.name,
            }}
          >
            {attachment?.name}
          </Typography>
        }
        headerRight={
          attachment && (
            <>
              {(checkCanRename ? checkCanRename(attachment) : true) && (
                <IconButton
                  ariaLabel={'rename'}
                  icon={'edit'}
                  color={'secondary'}
                  size={'small'}
                  variant={'icon'}
                  onClick={onRenameAudio}
                  tooltipProps={{
                    label: 'Rename',
                    placement: 'top',
                  }}
                />
              )}

              <IconButton
                ariaLabel={'delete'}
                icon={'close'}
                color={'secondary'}
                size={'small'}
                variant={'icon'}
                onClick={onRemoveAudio}
                tooltipProps={{
                  label: 'Remove',
                  placement: 'top',
                }}
              />
            </>
          )
        }
        content={
          <>
            <AudioPlayer
              url={attachment?.source}
              duration={attachment?.duration}
              fullWidth
              showDeliveryInfo={showDeliveryInfo}
              onError={(error) => {
                sentEventSentry({
                  event: '[Audio] RinglessAudio - error',
                  name: 'audio:error',
                  level: 'error',
                  error: error,
                })
              }}
            />
          </>
        }
      />
    )
  }
)
